export const getCookieName = (rateLimiterName: string): string => {
  return `rlimit-${rateLimiterName}`;
};

export const generateTimeExpression = (seconds: number) => {
  if (seconds === 0) {
    return '00:00';
  }

  const calcMin = Math.floor(seconds / 60);
  const calcSec = seconds - calcMin * 60;

  const minutesExpression = calcMin < 10 ? `0${calcMin}` : String(calcMin);
  const secondsExpression = calcSec < 10 ? `0${calcSec}` : String(calcSec);

  return `${minutesExpression}:${secondsExpression}`;
};

export const toNumber = (
  potentialNumber: string | null | undefined,
): number | undefined => {
  if (typeof potentialNumber === 'undefined' || potentialNumber === null) {
    return undefined;
  }

  return parseInt(potentialNumber, 10);
};
